<template>
    <div class="page-container">
        <!-- 头部横幅 -->
        <section class="hero">
            <div class="container">
                <h1>{{ title }}</h1>
                <p>{{ subtitle }}</p>
            </div>
        </section>
        <!-- 内容页面 -->
        <section class="page-content">
            <div class="card-list">
                <!-- 卡片组件：文案+图片，可循环渲染 -->
                <div class="beautiful-card" v-for="(item, index) in dataList" :key="index">
                    <!-- 卡片图片区域：优先展示，视觉吸引 -->
                    <div class="card-img-wrapper">
                        <img :src="item.picUrl" :alt="item.title" class="card-img" loading="lazy">
                        <!-- 图片角标（可选，提升层次感） -->
                        <!-- <div class="card-tag" v-if="item.tag">{{ item.tag }}</div> -->
                    </div>
                    
                    <!-- 卡片文案区域：留白充足，排版整洁 -->
                    <div class="card-content">
                        <h4 class="card-title">{{ item.title }}</h4>
                    <!-- <p class="card-desc" v-if="item.desc">{{ item.desc }}</p> -->
                    <!-- 文案底部辅助信息（可选，如时间/作者） -->
                    <!-- <div class="card-extra" v-if="item.extra">
                        <span>{{ item.extra }}</span>
                    </div> -->
                    </div>
                    
                    <!-- 卡片底部操作区（可选，提升交互性） -->
                    <!-- <div class="card-action" v-if="item.actionText">
                        <button @click="handleCardAction(item)" class="card-btn">
                            {{ item.actionText }} <i class="card-arrow">→</i>
                        </button>
                    </div> -->
                </div>
            </div>
        </section>
        <!-- 底部返回按钮 -->
        <Back></Back>
    </div>
</template>
<script>
import Back from '../components/Back.vue';

export default {
    name: "OneOnOneService",
    components: {
        Back
    },
    data() {
        return {
            title: 'One-on-one Service',
            subtitle: 'Customized Services Empower Enterprises to Sail Globally',
            dataList: [
                {
                    picUrl: "https://res.roadlinkglb.com/pic/os/cases/oneonone/one_shengfu.jpg",
                    title: "Shengfu Metal Products"
                },
                {
                    picUrl: "https://res.roadlinkglb.com/pic/os/cases/oneonone/one_fangzhi.jpg",
                    title: "Textile and Garment Industry Association"
                },
                {
                    picUrl: "https://res.roadlinkglb.com/pic/os/cases/oneonone/one_zhongwaihezuoyuanqu.jpg",
                    title: "China-foreign Cooperative Park"
                },
                {
                    picUrl: "https://res.roadlinkglb.com/pic/os/cases/oneonone/one_fulida.jpg",
                    title: "Fulida Down Products"
                },
                {
                    picUrl: "https://res.roadlinkglb.com/pic/os/cases/oneonone/one_helan.jpg",
                    title: "Netherlands Logistics Forum"
                },
                {
                    picUrl: "https://res.roadlinkglb.com/pic/os/cases/oneonone/one_chenghai.jpg",
                    title: "Chenghai Toy Association"
                },
                {
                    picUrl: "https://res.roadlinkglb.com/pic/os/cases/oneonone/one_aodaliyazhiye.jpg",
                    title: "Australia Night"
                },
                {
                    picUrl: "https://res.roadlinkglb.com/pic/os/cases/oneonone/one_xingypc.jpg",
                    title: "Star Shines Over Pengcheng",
                },
                {
                    
                    picUrl: "https://res.roadlinkglb.com/pic/os/cases/oneonone/one_jinhua.jpg",
                    title: "Jinhua Training Course"
                },
                {
                    
                    picUrl: "https://res.roadlinkglb.com/pic/os/cases/oneonone/one_guangkenxj.jpg",
                    title: "Guangken Rubber Group"
                },
                {
                    
                    picUrl: "https://res.roadlinkglb.com/pic/os/cases/oneonone/one_jingdonganlian.jpg",
                    title: "JD Allianz"
                },
                {
                    picUrl: "https://res.roadlinkglb.com/pic/os/cases/oneonone/one_lundunfazhanshu.jpg",
                    title: "London&Partners"
                },
                {
                    picUrl: "https://res.roadlinkglb.com/pic/os/cases/oneonone/one_ima.jpg",
                    title: "IMA Greater China Region"
                },
                {
                    picUrl: "https://res.roadlinkglb.com/pic/os/cases/oneonone/one_gongshanglian.jpg",
                    title: "Federation of Industry and Commerce"
                },
                {
                    picUrl: "https://res.roadlinkglb.com/pic/os/cases/oneonone/one_helanSavvy.jpg",
                    title: "Savvy"
                }

            ]
        }
    }
};
</script>

<style scoped>
/* 卡片列表：网格布局，留白合理，响应式适配 */
.card-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 2rem;
    padding: 2rem;
    max-width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
  }
  
  /* 核心卡片样式：圆角、阴影、悬浮效果，蓝白清新风 */
  .beautiful-card {
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    border-radius: 16px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    transition: all 0.4s ease;
    border: 1px solid #f0f7ff;
    height: 100%; /* 保证同排卡片高度一致 */
  }
  
  /* 卡片悬浮交互：轻微上浮+加深阴影，提升层次感 */
  .beautiful-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 30px rgba(24, 144, 255, 0.12);
    border-color: #e6f7ff;
  }
  
  /* 图片容器：固定宽高比，避免拉伸，溢出隐藏 */
  .card-img-wrapper {
    position: relative;
    width: 100%;
    padding-top: 60%; /* 16:9 优化为 5:3，更适配卡片文案布局 */
    overflow: hidden;
  }
  
  /* 卡片图片：保持比例，覆盖容器，过渡柔和 */
  .card-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s ease;
  }
  
  /* 图片悬浮放大：轻微缩放，提升视觉体验 */
  .beautiful-card:hover .card-img {
    transform: scale(1.05);
  }
  
  /* 图片角标：定位美观，配色醒目 */
  .card-tag {
    position: absolute;
    top: 1rem;
    left: 1rem;
    padding: 0.3rem 0.8rem;
    background-color: #1890ff;
    color: #ffffff;
    font-size: 0.8rem;
    border-radius: 20px;
    z-index: 10;
    box-shadow: 0 2px 8px rgba(24, 144, 255, 0.3);
  }
  
  /* 文案区域：留白充足，内边距合理，弹性布局占满剩余空间 */
  .card-content {
    flex: 1;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }
  
  /* 卡片标题：字体醒目，行高舒适，超出省略（避免换行错乱） */
  .card-title {
    font-size: 1.2rem;
    font-weight: 600;
    color: #1a3b69;
    line-height: 1.4;
    margin: 0;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    border-bottom: 0px;
  }
  
  /* 卡片描述：字体柔和，行高优秀，多行了省略 */
  .card-desc {
    font-size: 0.95rem;
    color: #597ea8;
    line-height: 1.7;
    margin: 0;
    flex: 1;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  
  /* 辅助信息：浅色调，小字体，区分主次 */
  .card-extra {
    font-size: 0.85rem;
    color: #99a9c4;
    margin-top: 0.5rem;
  }
  
  /* 操作按钮区域：内边距适配，边框分隔，保持整洁 */
  .card-action {
    padding: 0 1.5rem 1.5rem;
  }
  
  /* 操作按钮：蓝白配色，圆角柔和，交互清晰 */
  .card-btn {
    width: 100%;
    padding: 0.8rem 0;
    background-color: #f0f7ff;
    color: #1890ff;
    border: 1px solid #e6f7ff;
    border-radius: 8px;
    cursor: pointer;
    font-size: 0.95rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    transition: all 0.3s ease;
  }
  
  /* 按钮悬浮效果：加深背景，变色文字，提升交互感 */
  .card-btn:hover {
    background-color: #1890ff;
    color: #ffffff;
    border-color: #1890ff;
  }
  
  /* 箭头图标：悬浮跟随变色 */
  .card-arrow {
    font-size: 0.8rem;
    transition: transform 0.3s ease;
  }
  
  .card-btn:hover .card-arrow {
    transform: translateX(3px);
  }
  
  /* 响应式适配：移动端优化留白和尺寸 */
  @media (max-width: 768px) {
    .card-list {
      padding: 1rem;
      gap: 1.5rem;
      grid-template-columns: 1fr; /* 移动端单列布局，更易阅读 */
    }
  
    .beautiful-card {
      border-radius: 12px;
    }
  
    .card-img-wrapper {
      padding-top: 65%; /* 移动端图片稍高，提升视觉冲击 */
    }
  
    .card-content {
      padding: 1.2rem;
    }
  
    .card-title {
      font-size: 1.1rem;
    }
  
    .card-desc {
      font-size: 0.9rem;
    }
  
    .card-btn {
      padding: 0.7rem 0;
      font-size: 0.9rem;
    }
  }
  
  @media (max-width: 480px) {
    .card-list {
      padding: 0.8rem;
      gap: 1rem;
    }
  
    .card-img-wrapper {
      padding-top: 70%;
    }
  
    .card-content {
      padding: 1rem;
    }
  
    .card-tag {
      padding: 0.2rem 0.6rem;
      font-size: 0.7rem;
    }
  }

</style>